module.exports = __webpack_public_path__ + "8ab3c82cd9ac5078bb2466c390e2978f.svg";